import React, { ComponentType } from 'react';

import { GetUserClientFollowMappingsComponent, UserFollowMappings } from 'api';
import { QueryManager } from 'components';

export interface IWithUserClientFollowMappings {
  followMappings: UserFollowMappings;
}

const withUserClientFollowMappings = <T extends {}>(
  Component: ComponentType<T & IWithUserClientFollowMappings>,
) => (props: T) => (
  <GetUserClientFollowMappingsComponent>
    {queryResult => (
      <QueryManager {...queryResult}>
        {({ data }) => {
          if (!data || !data.getUserClientFollowMappings) {
            return null;
          }

          return <Component {...props} followMappings={data.getUserClientFollowMappings} />;
        }}
      </QueryManager>
    )}
  </GetUserClientFollowMappingsComponent>
);

export default withUserClientFollowMappings;
